/* tslint:disable */
import {
  PartnerAddress,
  ProductUom,
  Product,
  Company,
  StockLocation,
  StockMove,
  ManufacturingProductionOrder,
  StockWarehouseLocation,
  ManufacturingWorkLine,
  ManufacturingWorkShift,
  ProductionOrderInLine,
  ProductionOrderOutLine
} from '../index';

declare var Object: any;
export interface ProductionOrderInterface {
  "id"?: number;
  "name"?: string;
  "partner_id"?: number;
  "date"?: Date;
  "observations"?: string;
  "state"?: string;
  "in_line_ids"?: Array<any>;
  "out_line_ids"?: Array<any>;
  "production_hour_uom_qty"?: number;
  "production_hour_uom"?: number;
  "packages"?: number;
  "default_product_id"?: number;
  "company_id"?: number;
  "mixture"?: string;
  "production_filter"?: number;
  "in_location_id"?: number;
  "production_location_id"?: number;
  "out_location_id"?: number;
  "no_quality_location_id"?: number;
  "default_production_uom_qty"?: number;
  "default_production_uom"?: number;
  "default_packages"?: number;
  "in_move_ids"?: Array<any>;
  "with_manufacturing_domain"?: boolean;
  "out_move_ids"?: Array<any>;
  "mpo_id"?: number;
  "warehouse_location_id"?: number;
  "line_id"?: number;
  "shift_id"?: number;
  "timezone_date"?: Date;
  "production_order_ids"?: number;
  partner?: PartnerAddress;
  productionHourUom?: ProductUom;
  defaultProduct?: Product;
  company?: Company;
  inLocation?: StockLocation;
  outLocation?: StockLocation;
  productionLocation?: StockLocation;
  noQualityLocation?: StockLocation;
  defaultProductionUom?: ProductUom;
  inMoves?: StockMove[];
  outMoves?: StockMove[];
  mpo?: ManufacturingProductionOrder;
  warehouseLocation?: StockWarehouseLocation;
  line?: ManufacturingWorkLine;
  shift?: ManufacturingWorkShift;
  inLines?: ProductionOrderInLine[];
  outLines?: ProductionOrderOutLine[];
}

export class ProductionOrder implements ProductionOrderInterface {
  "id": number;
  "name": string;
  "partner_id": number;
  "date": Date;
  "observations": string;
  "state": string;
  "in_line_ids": Array<any>;
  "out_line_ids": Array<any>;
  "production_hour_uom_qty": number;
  "production_hour_uom": number;
  "packages": number;
  "default_product_id": number;
  "company_id": number;
  "mixture": string;
  "production_filter": number;
  "in_location_id": number;
  "production_location_id": number;
  "out_location_id": number;
  "no_quality_location_id": number;
  "default_production_uom_qty": number;
  "default_production_uom": number;
  "default_packages": number;
  "in_move_ids": Array<any>;
  "with_manufacturing_domain": boolean;
  "out_move_ids": Array<any>;
  "mpo_id": number;
  "warehouse_location_id": number;
  "line_id": number;
  "shift_id": number;
  "timezone_date": Date;
  "production_order_ids": number;
  partner: PartnerAddress;
  productionHourUom: ProductUom;
  defaultProduct: Product;
  company: Company;
  inLocation: StockLocation;
  outLocation: StockLocation;
  productionLocation: StockLocation;
  noQualityLocation: StockLocation;
  defaultProductionUom: ProductUom;
  inMoves: StockMove[];
  outMoves: StockMove[];
  mpo: ManufacturingProductionOrder;
  warehouseLocation: StockWarehouseLocation;
  line: ManufacturingWorkLine;
  shift: ManufacturingWorkShift;
  inLines: ProductionOrderInLine[];
  outLines: ProductionOrderOutLine[];
  constructor(data?: ProductionOrderInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProductionOrder`.
   */
  public static getModelName() {
    return "ProductionOrder";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProductionOrder for dynamic purposes.
  **/
  public static factory(data: ProductionOrderInterface): ProductionOrder{
    return new ProductionOrder(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProductionOrder',
      plural: 'ProductionOrders',
      path: 'ProductionOrders',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "partner_id": {
          name: 'partner_id',
          type: 'number'
        },
        "date": {
          name: 'date',
          type: 'Date'
        },
        "observations": {
          name: 'observations',
          type: 'string'
        },
        "state": {
          name: 'state',
          type: 'string'
        },
        "in_line_ids": {
          name: 'in_line_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "out_line_ids": {
          name: 'out_line_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "production_hour_uom_qty": {
          name: 'production_hour_uom_qty',
          type: 'number'
        },
        "production_hour_uom": {
          name: 'production_hour_uom',
          type: 'number'
        },
        "packages": {
          name: 'packages',
          type: 'number'
        },
        "default_product_id": {
          name: 'default_product_id',
          type: 'number'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
        "mixture": {
          name: 'mixture',
          type: 'string'
        },
        "production_filter": {
          name: 'production_filter',
          type: 'number'
        },
        "in_location_id": {
          name: 'in_location_id',
          type: 'number'
        },
        "production_location_id": {
          name: 'production_location_id',
          type: 'number'
        },
        "out_location_id": {
          name: 'out_location_id',
          type: 'number'
        },
        "no_quality_location_id": {
          name: 'no_quality_location_id',
          type: 'number'
        },
        "default_production_uom_qty": {
          name: 'default_production_uom_qty',
          type: 'number'
        },
        "default_production_uom": {
          name: 'default_production_uom',
          type: 'number'
        },
        "default_packages": {
          name: 'default_packages',
          type: 'number'
        },
        "in_move_ids": {
          name: 'in_move_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "with_manufacturing_domain": {
          name: 'with_manufacturing_domain',
          type: 'boolean'
        },
        "out_move_ids": {
          name: 'out_move_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "mpo_id": {
          name: 'mpo_id',
          type: 'number'
        },
        "warehouse_location_id": {
          name: 'warehouse_location_id',
          type: 'number'
        },
        "line_id": {
          name: 'line_id',
          type: 'number'
        },
        "shift_id": {
          name: 'shift_id',
          type: 'number'
        },
        "timezone_date": {
          name: 'timezone_date',
          type: 'Date'
        },
        "production_order_ids": {
          name: 'production_order_ids',
          type: 'number'
        },
      },
      relations: {
        partner: {
          name: 'partner',
          type: 'PartnerAddress',
          model: 'PartnerAddress',
          relationType: 'belongsTo',
                  keyFrom: 'partner_id',
          keyTo: 'id'
        },
        productionHourUom: {
          name: 'productionHourUom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'production_hour_uom',
          keyTo: 'id'
        },
        defaultProduct: {
          name: 'defaultProduct',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'default_product_id',
          keyTo: 'id'
        },
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'company_id',
          keyTo: 'id'
        },
        inLocation: {
          name: 'inLocation',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'in_location_id',
          keyTo: 'id'
        },
        outLocation: {
          name: 'outLocation',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'out_location_id',
          keyTo: 'id'
        },
        productionLocation: {
          name: 'productionLocation',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'production_location_id',
          keyTo: 'id'
        },
        noQualityLocation: {
          name: 'noQualityLocation',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'no_quality_location_id',
          keyTo: 'id'
        },
        defaultProductionUom: {
          name: 'defaultProductionUom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'default_production_uom',
          keyTo: 'id'
        },
        inMoves: {
          name: 'inMoves',
          type: 'StockMove[]',
          model: 'StockMove',
          relationType: 'referencesMany',
                  keyFrom: 'in_move_ids',
          keyTo: 'id'
        },
        outMoves: {
          name: 'outMoves',
          type: 'StockMove[]',
          model: 'StockMove',
          relationType: 'referencesMany',
                  keyFrom: 'out_move_ids',
          keyTo: 'id'
        },
        mpo: {
          name: 'mpo',
          type: 'ManufacturingProductionOrder',
          model: 'ManufacturingProductionOrder',
          relationType: 'belongsTo',
                  keyFrom: 'mpo_id',
          keyTo: 'id'
        },
        warehouseLocation: {
          name: 'warehouseLocation',
          type: 'StockWarehouseLocation',
          model: 'StockWarehouseLocation',
          relationType: 'belongsTo',
                  keyFrom: 'warehouse_location_id',
          keyTo: 'id'
        },
        line: {
          name: 'line',
          type: 'ManufacturingWorkLine',
          model: 'ManufacturingWorkLine',
          relationType: 'belongsTo',
                  keyFrom: 'line_id',
          keyTo: 'id'
        },
        shift: {
          name: 'shift',
          type: 'ManufacturingWorkShift',
          model: 'ManufacturingWorkShift',
          relationType: 'belongsTo',
                  keyFrom: 'shift_id',
          keyTo: 'id'
        },
        inLines: {
          name: 'inLines',
          type: 'ProductionOrderInLine[]',
          model: 'ProductionOrderInLine',
          relationType: 'referencesMany',
                  keyFrom: 'in_line_ids',
          keyTo: 'id'
        },
        outLines: {
          name: 'outLines',
          type: 'ProductionOrderOutLine[]',
          model: 'ProductionOrderOutLine',
          relationType: 'referencesMany',
                  keyFrom: 'out_line_ids',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ProductionOrder.ts